import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import Grey from '@material-ui/core/colors/grey';
import { withStyles } from '@material-ui/core';

const styles = {
	navigation: {
		margin: '10px',
		'& a': {
			textDecoration: 'none',
			color: Grey[600],
		},
	},
};

const Navigation = props => {
	const { links, currentLink, classes } = props;
	return (
		<Breadcrumbs aria-label="Breadcrumb" className={classes.navigation}>
			{links.map(link => (
				<Link key={link.title} to={link.to}>
					{link.title}
				</Link>
			))}
			<Typography color="textPrimary">{currentLink}</Typography>
		</Breadcrumbs>
	);
};

export default withStyles(styles)(Navigation);
